import React, { useState, useEffect, useContext } from 'react'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'

import DynamicIcon from '../../components/dynamicicon'
import JisButton from '../../components/controls/jisButton'
import JisPrompt from '../../components/jisprompt'
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import { TheaterComedyRounded } from '@mui/icons-material';
function PaymentGateway() {
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [gateways, setGateways] = useState([]);
    const [loading, setLoading] =useState(false);

       useEffect(() => {     
        
        onLoad();

                
          }, [])
   
             
          const onLoad= async()=>{
        //for account registration
         const url=`${Constants.apiUrl}/payment/gateways`;
        console.log(`the calling url ${url}`);
        try {
            setLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
          
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setGateways(data.gateways);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
   
        }

        const onSwitch=async(opt)=>{

             const url=`${Constants.apiUrl}/payment/switch-gateway/${opt.id}`;
        console.log(`the calling url ${url}`);
        try {
            setLoading(true);
            const resp = await fetch(url, { 
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
          
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setAlert({open:true, title:'Gateway Switch',subtitle:'Payment Gateway Switched successfully'});
                onLoad();
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
        }


    return (
    <div>
      <h1>Available Payment Gateway</h1>
     
        <div className='table'>
            <div class="section-cases">
                <span>Affidavit Documents</span><span className='total'>{gateways?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Date Created</th>
                        <th>Last Modified</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { gateways.map((gate, i) => { return (
                    <tr>
                        <td>{gate.name}</td>
                        <td>{gate.isActive?'Curent Payment':'Inactive'}</td>
                        <td>{gate.createdOn}</td>
                        <td>{gate.modifiedOn}</td>
                        <td>{gate.isActive?'Curent ':<JisButton onClick={()=>onSwitch(gate)}>Switch to {gate.name}</JisButton>}</td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
       <BackLoader open={loading}  /> 
    </div>
  );
}

export default PaymentGateway;